import { z } from 'zod';
import { DepositTransactionPayloadSchema } from './deposit-transaction.payload.entity';
import { WithdrawalTransactionPayloadSchema } from './withdrawal-transaction.payload.entity';
import { CurrencyConversionTransactionPayloadSchema } from './currency-conversion-transaction.payload.entity';
import { ChargeTransactionPayloadSchema } from './charge-transaction.payload.entity';

export const TransactionPayloadSchema = z.union([
    DepositTransactionPayloadSchema,
    WithdrawalTransactionPayloadSchema,
    CurrencyConversionTransactionPayloadSchema,
    ChargeTransactionPayloadSchema,
]);
